import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const campaignOrderList = (params = '') => Http.get(`/admin/campaign-orders${serialize(params)}`)
export const campaignOrderListUser = (params = '') => Http.get(`/campaign-orders${serialize(params)}`)
export const campaignOrderByID = (id) => Http.get(`/campaign-orders/${id}`)
export const campaignOrderCreate = (params) => Http.post('/admin/campaign-orders', params)
export const campaignOrderUpdate = (id, params = '') => Http.put(`/campaign-orders/${id}`, params)
export const campaignOrderDelete = (id) => Http.delete(`/admin/campaign-orders/${id}`)
export const campaignOrderTransition = (id, status) => Http.post(`/campaign-orders/${id}/transition`, { status })

// Mail Hub lead -> draft campaign (staff-only, never automatic; see agency-api's
// MailLeadConversionController). Lead id here is the api-main mail_leads numeric id.
export const mailLeadConvertToCampaign = (leadId) => Http.post(`/mail-leads/${leadId}/convert-to-campaign`)
export const campaignOrderContacts = (params = '') => Http.get(`/campaign-orders/contacts${serialize(params)}`)

// Creator Hub — campaign detail aggregations
export const campaignFinancials = (id) => Http.get(`/campaign-orders/${id}/financials`)
export const campaignContracts = (id) => Http.get(`/campaign-orders/${id}/contracts`)
export const campaignReport = (id) => Http.get(`/campaign-orders/${id}/report`)

// Complementary line items + agency catalog (Products/Bundles)
export const campaignItemsList = (orderId) => Http.get(`/campaign-orders/${orderId}/items`)
export const campaignItemCreate = (orderId, params) => Http.post(`/campaign-orders/${orderId}/items`, params)
export const campaignItemUpdate = (itemId, params) => Http.put(`/campaign-order-items/${itemId}`, params)
export const campaignItemDelete = (itemId) => Http.delete(`/campaign-order-items/${itemId}`)
export const campaignCatalog = (params = '') => Http.get(`/campaign-catalog${serialize(params)}`)
export const campaignGenerateProposal = (id) => Http.post(`/campaign-orders/${id}/proposal`, {})

// Tracking / results
export const campaignCoverages = (id) => Http.get(`/campaign-orders/${id}/coverages`)
export const campaignObjectiveActual = (objectiveId, params) => Http.put(`/campaign-objectives/${objectiveId}/actual`, params)

// Client results report — shareable link, CSV export, import to Case
export const campaignClientReport = (id) => Http.get(`/campaign-orders/${id}/client-report`)
export const campaignReportToken = (id) => Http.post(`/campaign-orders/${id}/report-token`)
export const campaignReportSend = (id, email) => Http.post(`/campaign-orders/${id}/send-report`, email ? { email } : {})
export const campaignReportCsvUrl = (id) => `${import.meta.env.VITE_API_BASE_URL}/campaign-orders/${id}/report.csv`
export const campaignExportToCase = (id) => Http.post(`/campaign-orders/${id}/export-to-case`)

// Coverage ingest — manual + paste-to-autofill + prints + dedupe
export const campaignCoveragePreviewUrl = (params) => Http.post('/campaign-coverages/preview-url', params)
export const campaignCoverageCreate = (orderId, params) => Http.post(`/campaign-orders/${orderId}/coverages`, params)
export const campaignCoverageUpdate = (coverageId, params) => Http.put(`/campaign-coverages/${coverageId}`, params)
export const campaignCoverageDelete = (coverageId) => Http.delete(`/campaign-coverages/${coverageId}`)

// Push notifications — manual log (no live delivery/open tracking exists)
export const campaignPushNotifications = (orderId) => Http.get(`/campaign-orders/${orderId}/push-notifications`)
export const campaignPushNotificationCreate = (orderId, params) => Http.post(`/campaign-orders/${orderId}/push-notifications`, params)
export const campaignPushNotificationDelete = (id) => Http.delete(`/campaign-push-notifications/${id}`)

// Press releases — attach an existing press release campaign to this order (canonical, campaign-detail-driven linking)
export const pressReleaseCampaignSearch = (params = '') => Http.get(`/press-release-campaigns${serialize(params)}`)
export const pressReleaseCampaignAttach = (campaignId, campaignOrderId) => Http.post(`/press-release-campaigns/${campaignId}/attach-campaign`, { campaign_order_id: campaignOrderId })

// Key campaigns — attach an existing key pool (with real redemptions) to this order
export const campaignKeys = (orderId) => Http.get(`/campaign-orders/${orderId}/keys`)
export const campaignKeySearch = (params = '') => Http.get(`/campaign-orders/keys/search${serialize(params)}`)
export const campaignKeyAttach = (orderId, keyId) => Http.post(`/campaign-orders/${orderId}/attach-key-campaign`, { key_id: keyId })
export const campaignKeyDetach = (orderId, keyId) => Http.delete(`/campaign-orders/${orderId}/keys/${keyId}`)

// Coverage discovery (Google) — suggestions
export const campaignCoverageSuggestions = (params = '') => Http.get(`/campaign-coverage-suggestions${serialize(params)}`)
export const campaignCoverageDiscoverRun = (orderId, params = {}) => Http.post(`/campaign-orders/${orderId}/coverage-suggestions/run`, params)
export const campaignCoverageSuggestionApprove = (id) => Http.post(`/campaign-coverage-suggestions/${id}/approve`)
export const campaignCoverageSuggestionDismiss = (id) => Http.post(`/campaign-coverage-suggestions/${id}/dismiss`)

// Press release — external tracking pixel
export const pressReleasePixel = (campaignId, email = '') =>
  Http.get(`/press-release-campaigns/${campaignId}/pixel${email ? `?email=${encodeURIComponent(email)}` : ''}`)

// Standalone email tracking pixels (api-main shared module)
export const emailPixelList = (params = '') => Http.get(`/email-pixels${serialize(params)}`)
export const emailPixelCreate = (params) => Http.post('/email-pixels', params)
export const emailPixelShow = (id) => Http.get(`/email-pixels/${id}`)
